import VistaprintAuth from "@vp/auth"
const jwtDecode = require("jwt-decode")

const auth = new VistaprintAuth.WebAuth()

export function getRequestConfigWithAuth(): { headers: Record<string, string> } {
	return {
		headers: {
			Authorization: `Bearer ${getAccessToken()}`,
			"Content-Type": "application/json",
		},
	}
}

export function getAccessToken(): string {
	return auth.getToken()
}

export function getEmailFromAccessToken(): string {
	try {
		const decoded = jwtDecode(auth.getToken())
		return decoded["https://claims.cimpress.io/canonical_id"]
	} catch (err) {
		console.error("unknownActor")
		return ""
	}
}
